import { Box, Tooltip } from '@mui/material'
import React from 'react'
import MenuList from './MenuList'

const SeatMenu = (props) => {
    const { children = <></>, obj = {}, bkgDeatails = {}, userDetails = {}, seatInfoDrop = false, setSeatInfoDrop = () => { }, setTooltipOpen = () => { },handleSeatModDetails=()=>{} } = props
    let disableTooltip = obj.ForAgentID !== userDetails?.AgentID && obj.IsBkgAvailable === 1
    return (
        <Box sx={{ height: '100%' }}>
            <Tooltip
                arrow
                disablePortal
                open={seatInfoDrop}
                placement={'right'}
                disableHoverListener={disableTooltip}
                disableFocusListener={disableTooltip}
                disableTouchListener={disableTooltip}
                PopperProps={{
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 0],
                            },

                        },
                        {
                            name: 'arrow',
                            options: { padding: 10, },
                        },
                    ],
                    sx: {
                        '& .MuiTooltip-tooltip': {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                            padding: 0,
                            zIndex: 1400,
                        },
                        '& .MuiTooltip-arrow': {
                            color: '#FAF9F6',
                            width: '22px',
                            height: '13px',


                        },
                        '&[data-popper-placement^="bottom"] .MuiTooltip-arrow': {
                            color: '#0086FF',
                        },
                    },
                }}

                title={
                    <MenuList
                        ell={obj}
                        setSeatInfoDrop={setSeatInfoDrop}
                        setTooltipOpen={setTooltipOpen}
                        userDetails={userDetails}
                        bkgDeatails={bkgDeatails}
                        handleSeatModDetails={handleSeatModDetails}
                    />
                }

            >
                {children}

            </Tooltip>
        </Box>
    )
}

export default SeatMenu